const colors = {
  primary: 'black',
  disabled: 'gray',
  white: 'white',
  black: 'black',
  tint: 'rgba(0,0,0,0.1)',
  transparentBlack: 'rgba(0,0,0,0.5)',
  transparent: 'rgba(0,0,0,0)',
  danger: '#D9534F',
  listBackground: 'rgba(0,0,0,0.1)',
  validGreen: '#139679',
  fff: '#fff',
  timerBackground: '#f4daa3',
}

export default colors
